import { KEPT_KINDS, type KeptKind, type RunRemovalPreview } from "../../../api/threads/runRemovalApi";

/** What goes, as the dialog counts it: the Runs (a batch's own Runs among them) and their data-model results. */
export type GoneKind = "runs" | "results";

export interface RemovalLine<Kind extends string> {
  readonly kind: Kind;
  readonly count: number;
}

export interface RemovalLines {
  readonly goes: readonly RemovalLine<GoneKind>[];
  readonly keeps: readonly RemovalLine<KeptKind>[];
}

const GONE_KINDS: readonly GoneKind[] = ["runs", "results"];

/** The Remove dialog's lines: each kind with any, in one order. A batch shows through its Runs, which are counted. */
export function removalLines(preview: RunRemovalPreview): RemovalLines {
  return {
    goes: GONE_KINDS.flatMap((kind) => (preview[kind] > 0 ? [{ kind, count: preview[kind] }] : [])),
    keeps: KEPT_KINDS.flatMap((kind) => {
      const count = preview.kept[kind] ?? 0;
      return count > 0 ? [{ kind, count }] : [];
    }),
  };
}
